module.exports = __webpack_public_path__ + "img/day_one.68c0eb5b.svg";